<template>
	<div class="workbench">
		<div class="workbench-header">
			<div class="welcome-section">
				<div class="welcome-icon">
					<i class="el-icon-sunny"></i>
				</div>
				<div class="welcome-text">
					<h1>欢迎您，{{ userChName }}</h1>
					<p>登录门店订单管理系统</p>
				</div>
			</div>
		</div>

		<div class="workbench-content">
			<div class="statistics-row">
				<storeStatistic ref="storeStatistic"></storeStatistic>
			</div>

			<div class="customer-row">
				<customerStatistic ref="customerStatistic"></customerStatistic>
			</div>

			<div class="chart-row">
				<storeMonthNumStatistic ref="storeMonthNumStatistic"></storeMonthNumStatistic>
			</div>
		</div>
	</div>
</template>

<script>
import storeStatistic from "./storeStatistic.vue";
import storeMonthNumStatistic from "./storeMonthNumStatistic.vue";
import customerStatistic from "./customerStatistic.vue";
export default {
	data() {
		return {
			userChName: "用户",
			roleName: "角色",
			deptName: "部门"
		};
	},
	components: {
		storeStatistic,
		storeMonthNumStatistic,
		customerStatistic
	},

	created() {
		this.GetUserInfo();
	},

	mounted() {},

	methods: {
		GetUserInfo() {
			let userdata = JSON.parse(localStorage.getItem("userdata"));
			if (userdata) {
				this.userChName = userdata.userInfo.chName;
				this.roleName = userdata.roleInfo.roleName;
				this.deptName = userdata.userInfo.dept;
			}
		}
	}
};
</script>

<style scoped lang="scss">
.workbench {
	width: 100%;
	height: calc(100vh - 75px);
	background: linear-gradient(180deg, #eef3fb 0%, #f6f8fc 100%);
	padding: 16px;
	box-sizing: border-box;
	overflow-y: auto;
	position: relative;
}

.workbench-header {
	margin-bottom: 16px;
}

.welcome-section {
	display: flex;
	align-items: center;
	background: linear-gradient(135deg, #1d4ed8 0%, #2563eb 45%, #0f766e 100%);
	padding: 22px 24px;
	border-radius: 12px;
	box-shadow: 0 8px 28px rgba(29, 78, 216, 0.22);
}

.welcome-icon {
	width: 56px;
	height: 56px;
	background: rgba(255, 255, 255, 0.14);
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-right: 16px;

	i {
		font-size: 28px;
		color: #fff;
	}
}

.welcome-text {
	h1 {
		margin: 0;
		font-size: 24px;
		font-weight: 600;
		color: #fff;
		font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
	}

	p {
		margin: 6px 0 0 0;
		font-size: 13px;
		color: rgba(255, 255, 255, 0.85);
	}
}

.workbench-content {
	display: flex;
	flex-direction: column;
	gap: 16px;
	margin-top: 4px;
}

.statistics-row {
	width: 100%;
}

.customer-row {
	width: 100%;
}

.chart-row {
	width: 100%;
	min-height: 400px;
}

@media (max-width: 1200px) {
	.workbench {
		padding: 12px;
	}

	.welcome-section {
		padding: 16px 20px;
	}

	.welcome-icon {
		width: 48px;
		height: 48px;

		i {
			font-size: 24px;
		}
	}

	.welcome-text {
		h1 {
			font-size: 20px;
		}
	}

	.chart-row {
		min-height: 350px;
	}
}

@media (max-width: 768px) {
	.workbench {
		padding: 8px;
	}

	.welcome-section {
		padding: 12px 16px;
	}

	.welcome-icon {
		width: 40px;
		height: 40px;
		margin-right: 12px;

		i {
			font-size: 20px;
		}
	}

	.welcome-text {
		h1 {
			font-size: 16px;
		}

		p {
			font-size: 11px;
		}
	}

	.chart-row {
		min-height: 300px;
	}
}
</style>
